// extracted by mini-css-extract-plugin
export default {"kukariScore":"styles_kukariScore__LMsuR"};